import { getLkApi, getGubaApi } from '../apidata';
import tiptoast from '../modal/tiptoast';
import transFace from "../face";
import { debounce, dateFormat } from '../utils';

let _env = "production";
// if (window.location.hostname != 'roadshow.eastmoney.com') {
//   _env = "test";
// };

// 标签类型(notlangke 原非浪客创建的特殊视角类型)
let listTypes = {
  notlangke: [
    { name: "全部", type: 0 },
    { name: "提到我的", type: 2 },
    { name: "已精选", type: 6 },
    { name: "未回答", type: 3 },
    { name: "已回答", type: 4 },
    { name: "回收站", type: 5 },
  ],
  user: [
    { name: "全部", type: 0 },
    { name: "我的提问", type: 1 },
  ],
  guest: [
    { name: "全部", type: 0 },
    { name: "未回答", type: 33 },
    { name: "已回答", type: 31 },
    { name: "待修改", type: 32 },
    { name: "回收站", type: 34 },
  ],
  presenter: [
    { name: "全部", type: 0 },
    { name: "已精选", type: 6 },
    { name: "已派发", type: 22 },
    { name: "待审核", type: 23 },
    { name: "回收站", type: 21 },
  ]
};


/**
 * 互动区按钮事件
 * @param this 
 */
export default function bindChatEvens(this: any, accountInfo: any) {

  let that = this;
  // 删除
  $('.luyan_content').on('click', '.btn_delete', async function () {
    let postid: string = $(this).data('pd');
    let answerid: string = $(this).data('ad');
    let replyid: string = $(this).data('rd');
    try {
      // 
      if (answerid == "0") {
        let json = await getGubaApi('wzzbopt/JSONP/LiveReplyDelDraftAnswer', {
          tid: accountInfo.id,
          huifuid: replyid,
          t_type: 59,
          action: this.uid
        })
      } else {
        let json = await getGubaApi('replyopt/JSONP/DeleteUserReply', { // replyopt 不变
          postid,
          replyid: answerid
        })
      }
    } catch (error) {
      console.log(error)
    }

    $(this).parents('.item').find('.ask_wrap').remove();
    $(this).html('回复').removeClass('btn_delete').addClass('btn_replay');
  });

  //忽略 & 取消
  $('.luyan_content').on('click', '.btn_ignore', async function () {
    let replyid: string = $(this).data('rd');
    let ignoretype: string = $(this).data('ignoretype');
    let action = ignoretype == "ignore" ? 1 : 2;
    try {
      let json = await getGubaApi('wzzbopt/JSONP/LiveReplyRecycle', {
        tid: accountInfo.id,  //tid 指的是房间号
        huifuid: replyid,
        t_type: 59,
        action: action   //操作,1:忽略提问,进回收站 2:取消忽略提问,从回收站移出
      });
      if (!!json?.me) {
        // 0 成功
        // 300：该提问已抢先被其他嘉宾忽略
        // 301：该提问已抢先被其他嘉宾回复，无法忽略
        if (json?.error_code == 300 || json?.error_code == 0) {
          $(this).parents('.item').fadeOut(); //remove()
        };
        tiptoast.show({
          content: json?.me || "",
          callback: function () { }
        });
      };
    } catch (error) {
      console.log(error)
    }

  });

  // 精选 & 取消精选
  $('.luyan_content').on('click', '.btn_selected', async function () {
    let replyid: string = $(this).data('rd');
    let selecttype: any = $(this).attr('data-selecttype');

    let action = selecttype == "selected" ? 1 : 2;
    try {
      let json = await getGubaApi('wzzbopt/JSONP/LiveReplyCareSelect', {
        tid: accountInfo.id,  //tid 指的是房间号
        huifuid: replyid,
        t_type: 59,
        action: action   //1:精选操作 2:取消精选操作
      });
      if (!!json?.me) {

        // 0 成功
        if (json?.error_code == 0) {
          // $(this).parents('.item').fadeOut(); //remove()
          if (selecttype == "selected") {
            $(this).text("取消精选").attr("data-selecttype", "cancelselect")

          }
          else {
            $(this).text("精选").attr("data-selecttype", "selected")
            // 精选列表下取消成功直接移除
            if (that.type == 6) {
              $(this).parents('.item').fadeOut();
            }
          }
        };
        // 该提问已抢先被其他嘉宾忽略
        if (json?.error_code == 302) {
          $(this).parents('.item').fadeOut();
        }
        tiptoast.show({
          content: json?.me || "",
          callback: function () { }
        });
      };
    } catch (error) {
      console.log(error)
    }

  });

  // 主持人审核通过
  $('.luyan_content').on('click', '.btn_passreply', async function () {
    let replyid: string = $(this).data('rd');
    let text: string = decodeURIComponent($(this).data('at'));
    let pic: string = $(this).data('ap');
    let aid: string = $(this).data('aid');
    try {
      let json = await getGubaApi('wzzbopt/JSONP/LiveReplyGuidePass', {
        tid: accountInfo.id,  //tid 指的是房间号
        huifuid: replyid,
        t_type: 59,
        text: text,  // 回答内容
        pic: pic, // 回答图片
        answer_uid: aid, // 回复人uid
      });

      if (!!json?.rc) {
        // 0 成功
        if (json?.error_code == 0) {
          $(this).parents('.item').fadeOut();
        };
      };

      if (!!json?.me) {
        tiptoast.show({
          content: json?.me || "",
          callback: function () { }
        });
      };
    } catch (error) {
      console.log(error)
    }

  });

  // 主持人审核-返回修改
  $('.luyan_content').on('click', '.btn_backedit', async function () {
    let replyid: string = $(this).data('rd');
    let aid: string = $(this).data('aid');
    try {
      let json = await getGubaApi('wzzbopt/JSONP/LiveReplyBackAnswer', {
        tid: accountInfo.id,  //tid 指的是房间号
        huifuid: replyid,
        t_type: 59,
        answer_uid: aid, // 回复人uid
      });

      if (!!json?.rc) {
        // 0 成功
        if (json?.error_code == 0) {
          $(this).parents('.item').fadeOut();
        };
      };

      if (!!json?.me) {
        tiptoast.show({
          content: json?.me || "",
          callback: function () { }
        });
      };
    } catch (error) {
      console.log(error)
    }

  });

  // 嘉宾修改
  $('.luyan_content').on('click', '.btn_guestedit', async function () {
    let $this = $(this);
    let replyid: string = $(this).data('rd'), // reply_id
      postid: string = $(this).data('pd'), // source_post_id
      answerid: any = $(this).data('answerid'),
      at: string = decodeURIComponent($(this).data('at')), // answer_text 
      ap: string = $(this).data('ap'), //answer_reply_picture
      aid: any = $(this).data('answeruid'); //answer_user.user_id
    let huifuid = answerid == 0 ? replyid : answerid;

    let $item = $this.parents('.item');
    let replyDom: JQuery<HTMLElement> = (<any>$)(`<div class="guba_reply_editor"></div>`);
    let pickDOm: JQuery<HTMLElement> = (<any>$)(`<div class="pick_up">收起</div>`);
    let option: any = {
      thisSe: replyDom,
      isReply: true, // 是回复还是发言
      postData: that.getGubaPostDataForEdit({
        // tid: replyid,
        huifuid: huifuid,
        answer_uid: aid,
        pic: ap,
        text: at,
        userType: 2
      }),
      callback: function (json: any) { //text: string, id: string
        console.log(json)
        let reply = json?.reply
        let text = transFace(reply?.answer_text);
        let imgstr = reply?.answer_reply_picture ? `<img class="chatimg" src=${reply?.answer_reply_picture}>` : "";
        // 数据假发
        // let info = that.getSpecialUserInfo();
        // let html = `<div class="ask_wrap">
        //                   <div class="info">
        //                       <h4 class="name"><span class="reply_tag">回复</span> ${info.name}</h4>
        //                       <p class="time">${dateFormat(new Date(), "yyyy-MM-dd HH:mm")}</p>
        //                   </div>
        //                   <div class="ask_con">${text}${imgstr}</div>
        //               </div>
        //               <div class="btn_container">
        //                 <button class="btn_guestedit" 
        //                 data-pd="${reply.source_post_id}" 
        //                 data-rd="${reply.reply_id}"
        //                 data-answerid="${reply.answer_id}"
        //                 data-at="${reply.answer_text}"
        //                 data-ap="${reply.answer_reply_picture}"
        //                 data-answeruid="${reply.answer_user.user_id}"
        //                 data-name="${reply.reply_user.user_nickname}">修改</button>
        //               </div>
        //               `
        // replyDom.remove();
        // pickDOm.remove();
        // $item.find(".ask_wrap").remove();
        // $item.find(".btn_container").remove();
        // $item.find('.answer_con').after(html);
        $item.fadeOut();
      }
    }

    if (_env == 'test') {
      option = $.extend(option, { env: _env })  ////测试用，发布上线不要传
    };

    $(this).parent().after(replyDom);
    $(this).hide();

    $(this).after(pickDOm);
    if ((<any>window)?.retext_replyEditor) {
      (<any>window).retext_replyEditor(option);
    }

  });

  // 主持人修改嘉宾
  $('.luyan_content').on('click', '.btn_presentedit', async function () {
    let $this = $(this);
    let replyid: string = $(this).data('rd'), // reply_id
      postid: string = $(this).data('pd'), // source_post_id
      answerid: any = $(this).data('answerid'),
      at: string = decodeURIComponent($(this).data('at')), // answer_text 
      ap: string = $(this).data('ap'), //answer_reply_picture
      aid: any = $(this).data('answeruid'); //answer_user.user_id
    let huifuid = answerid == 0 ? replyid : answerid

    let $item = $this.parents('.item');
    let replyDom: JQuery<HTMLElement> = (<any>$)(`<div class="guba_reply_editor"></div>`);
    let pickDOm: JQuery<HTMLElement> = (<any>$)(`<div class="pick_up">收起</div>`);
    let option: any = {
      thisSe: replyDom,
      isReply: true, // 是回复还是发言
      postData: that.getGubaPostDataForEdit({
        // tid: replyid,
        huifuid: huifuid,
        answer_uid: aid,
        pic: ap,
        text: at,
        userType: 3
      }),
      callback: function (json: any) { //text: string, id: string
        console.log(json)
        $item.fadeOut();
      }
    }

    if (_env == 'test') {
      option = $.extend(option, { env: _env })  ////测试用，发布上线不要传
    };

    $(this).parent().after(replyDom);
    $(this).hide();

    $(this).after(pickDOm);
    if ((<any>window)?.retext_replyEditor) {
      (<any>window).retext_replyEditor(option);
    }

  });

  // 派发嘉宾列表
  var getGuestlist = function (guests: Array<any>) {
    let $dom = guests.map(v => {
      let name = v.target_nickname || v.nickname;
      let position = v.position || "";
      return `<p class="pfn" data-guid="${v.emuid}" data-targetnickname="${v.target_nickname}" data-nickname="${v.nickname}" data-position="${v.position}">${position} ${name}</p>`
    });
    return `<div class="pf_glist">${$dom.join("")}</div>`
  };

  // 派发
  $('.luyan_content').on('click', '.btn_paifa', async function () {
    let guestdom = getGuestlist(that.guests);
    if ($(this).siblings(".pf_glist").length) {
      $(this).siblings(".pf_glist").remove();
    } else {
      $(this).parent().append($(guestdom));
    };

    return false;
  });

  // 派发提交
  $('.luyan_content').on('click', '.pfn', async function () {
    let $pfbtn = $(this).parent(".pf_glist").siblings(".btn_paifa");
    let replyid: string = $pfbtn.data('rd');
    let guid = $(this).data("guid");
    let gname = $(this).data("targetnickname") || $(this).data("nickname");

    try {
      let json = await getGubaApi('wzzbopt/JSONP/LiveReplyPaifa', {
        tid: accountInfo.id,  //tid 指的是房间号
        huifuid: replyid,
        t_type: 59,
        action: 1,  // 操作,1:派发，默认为1
        paifauid: guid  // 测试
      });

      if (!!json?.me) {
        // 0 成功
        if (json?.error_code == 0 && json?.rc == 1) {
          $pfbtn.parents('.item').find(".btn_ignore").remove();
          $pfbtn.replaceWith(`<span class="paifalab">已分派给嘉宾${gname}</span>`);
          $(this).parent(".pf_glist").remove();
        };

        if (json?.error_code == 303) {
          $(this).parents('.item').fadeOut();
        };

        tiptoast.show({
          content: json?.me || "",
          callback: function () { }
        });
      };
    } catch (error) {
      console.log(error)
    }
  });

  // 收起派发嘉宾列表
  $("body").on("click", function (e) {
    if (!$(e.target).parents(".paifa-wrap")?.length) {
      $(".pf_glist").remove();
      // return false;
    }
  });

  // 一键派发啊
  $('.luyan_top').on('click', '.paifaAll', async function () {
    try {
      let json = await getGubaApi('wzzbopt/JSONP/LiveReplyPaifaAll', {
        tid: accountInfo.id,  //tid 指的是房间号
        t_type: 59
      });

      // 0 成功
      if (json?.error_code == 0 && json?.rc == 1) {
        $(".luyan_tabs").find("li").eq(0).trigger("click");
      };

      if (!!json?.me) {
        tiptoast.show({
          content: json?.me || "",
          callback: function () { }
        });
      };
    } catch (error) {
      console.log(error)
    }
  });

  // 回复
  $('.luyan_content').on('click', '.btn_replay', async function () {
    let $this = $(this);
    let replyid: string = $(this).data('rd');
    let postid: string = $(this).data('pd');
    let name: string = $(this).data('name');

    let $item = $this.parents('.item');
    let replyDom: JQuery<HTMLElement> = (<any>$)(`<div class="guba_reply_editor"></div>`);
    let pickDOm: JQuery<HTMLElement> = (<any>$)(`<div class="pick_up">收起</div>`);
    let option: any = {
      thisSe: replyDom,
      isReply: true, // 是回复还是发言
      postData: that.getGubaPostData({
        reId: replyid,
        reName: name
      }),
      callback: function (json: any) { //text: string, id: string

        let text = transFace(json?.reply?.answer_text);
        let imgstr = json?.reply?.answer_reply_picture ? `<img class="chatimg" src=${json?.reply?.answer_reply_picture}>` : "";
        // 数据假发
        let info = that.getSpecialUserInfo();
        let html = `<div class="ask_wrap">
                          <div class="info">
                              <h4 class="name"><span class="reply_tag">回复</span> ${info.name}</h4>
                              <p class="time">${dateFormat(new Date(), "yyyy-MM-dd HH:mm")}</p>
                          </div>
                          <div class="ask_con">${text}${imgstr}</div>
                      </div>
                      <div class="btn_container">
                          <button class="btn_delete" data-pd="${postid}" data-name="${name}"  data-ad="${json?.reply_id}" data-rd="${replyid}">删除</button>
                      </div>
                      `
        replyDom.remove();
        pickDOm.remove();
        $item.find('.answer_con').after(html);

        $this.siblings(".btn_ignore").hide();
        $this.siblings(".btn_selected").hide();

      }
    }

    if (_env == 'test') {
      option = $.extend(option, { env: _env })  ////测试用，发布上线不要传
    }

    $(this).parent().after(replyDom);
    $(this).hide();
    // $(this).siblings(".btn_ignore").hide();
    $(this).after(pickDOm);
    if ((<any>window)?.replyEditor) {
      (<any>window).replyEditor(option);
    }

  });

  //收起
  $('.luyan_content').on('click', '.pick_up', function () {
    $(this).parent().next().remove();
    $(this).prev().show();
    $(this).hide();
  });
}